export type { Theme, ThemeColors } from './types.js'
export { constructionGreen } from './construction-green.js'
export { slatePro } from './slate-pro.js'
export { navyIndustrial } from './navy-industrial.js'
export { graphite } from './graphite.js'

import type { Theme } from './types.js'
import { constructionGreen } from './construction-green.js'
import { slatePro } from './slate-pro.js'
import { navyIndustrial } from './navy-industrial.js'
import { graphite } from './graphite.js'

export const THEMES: Record<string, Theme> = {
  'construction-green': constructionGreen,
  'slate-pro': slatePro,
  'navy-industrial': navyIndustrial,
  'graphite': graphite,
}

export const DEFAULT_THEME_ID = 'construction-green'
